var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-2"},[_c('div',{staticStyle:{"min-height":"4px"}},[_c('v-progress-linear',{attrs:{"active":_vm.show,"indeterminate":_vm.query,"query":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }